import { createFileRoute } from "@tanstack/react-router";
import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { TrackRow } from "@/components/TrackRow";
import type { Track } from "@/stores/player";
import { Heart } from "lucide-react";

export const Route = createFileRoute("/_authed/favorites")({
  head: () => ({ meta: [{ title: "Favorites — Sura" }] }),
  component: FavoritesPage,
});

function FavoritesPage() {
  const [tracks, setTracks] = useState<Track[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/api/favorites").then(({ data }) => {
      const items = data.favorites || data.tracks || data || [];
      setTracks(items.map((x: any) => x.track || x));
    }).finally(() => setLoading(false));
  }, []);

  return (
    <div className="px-4 md:px-8 py-6 md:py-10 max-w-4xl mx-auto">
      <div className="flex items-center gap-3 mb-6">
        <div className="h-12 w-12 rounded-xl bg-destructive/10 flex items-center justify-center">
          <Heart className="h-6 w-6 fill-destructive text-destructive" />
        </div>
        <div>
          <h1 className="text-2xl md:text-3xl font-bold tracking-tight">Favorites</h1>
          <p className="text-sm text-muted-foreground">{tracks.length} tracks</p>
        </div>
      </div>

      {loading ? (
        <div className="text-center text-muted-foreground py-12">Loading…</div>
      ) : tracks.length === 0 ? (
        <div className="text-center text-muted-foreground py-20">No favorites yet.</div>
      ) : (
        <div className="bg-card border border-border rounded-2xl p-2">
          {tracks.map((t, i) => (
            <TrackRow
              key={t.id}
              track={t}
              index={i}
              queue={tracks}
              isFavorite
              onUnfavorite={(id) => setTracks((prev) => prev.filter((x) => x.id !== id))}
            />
          ))}
        </div>
      )}
    </div>
  );
}
